module.exports = __webpack_public_path__ + "static/media/avatar-H_K.0213bc4c.png";